import { render, staticRenderFns } from "./Say.vue?vue&type=template&id=1c9253f2&"
import script from "./Say.vue?vue&type=script&lang=js&"
export * from "./Say.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports